// extracted by mini-css-extract-plugin
module.exports = {"lightColor":"TitleWidget_lightColor__2iET3","mediumColor":"TitleWidget_mediumColor__2w2oM","darkColor":"TitleWidget_darkColor__2RhKu"};